import Raven from 'raven-js'

// Raven requires a DSN but it will not be used because of our custom transport
// definition.
Raven.config('//example.com/', {
    transport: function(options) {
        if (isNetworkError(options.data)) {
            return
        }

        if (isWebExtensionError(options.data)) {
            return
        }

        if (isAbort(options.data)) {
            return
        }

        if (isResizeObserverError(options.data)) {
            return
        }

        if (isBannedTrialHostError(options.data)) {
            return
        }

        if (jQuery('#pagecontent').find('.alert-danger').length === 0) {
            jQuery('#pagecontent').prepend(
                '<div class="alert alert-danger alert-dismissible">' +
                    '<a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>' +
                    '<strong>We are sorry – an error occured.</strong><br />' +
                    '<p>You encountered a JavaScript error – this is not supposed to happen and <strong>refreshing the ' +
                    'page usually fixes the problem</strong>. In addition we have logged this error and will work on ' +
                    'fixing this problem as soon as possible.</p>' +
                    '</div>',
            )
        }

        jQuery.ajax({
            type: 'POST',
            url: '/error/js',
            data: options.data,
            dataType: 'json',
        })
    },
}).install()

jQuery(document).ajaxError(function(ev, jqXHR, settings) {
    // network errors leave empty responses
    if (typeof jqXHR.responseText === 'undefined') {
        return
    }

    try {
        var msg = jQuery.parseJSON(jqXHR.responseText)
    } catch {
        return
    }

    if (typeof msg.exception !== 'undefined') {
        console.log('Exception in Ajax call to ' + settings.url, msg.exception)
    }
})

// https://medium.com/@vinhlh/how-to-handle-networkerror-when-using-fetch-ff2663220435
const isNetworkError = data => {
    let message = ''
    if ('exceptions' in data) {
        message = data.exceptions.values[0].value
    }

    if ('exception' in data) {
        message = data.exception.values[0].value
    }

    if (message === '') {
        return
    }

    return (
        message === 'NetworkError when attempting to fetch resource.' ||
        message === 'Failed to fetch' ||
        message === 'Network request failed'
    )
}

const isResizeObserverError = data => {
    let message = ''
    if ('exceptions' in data) {
        message = data.exceptions.values[0].value
    }

    if ('exception' in data) {
        message = data.exception.values[0].value
    }

    if (message === '') {
        return
    }

    return message === 'ResizeObserver loop limit exceeded' || message === 'ResizeObserver loop completed with undelivered notifications.'
}

const isWebExtensionError = data => {
    if (data.culprit.indexOf('safari-web-extension://') === 0) {
        return true
    }

    if (data.culprit.indexOf('webkit-masked-url://') === 0) {
        return true
    }

    if (data.culprit.indexOf('chrome-extension://') === 0) {
        return true
    }

    return false
}

const isAbort = data => {
    if ('exception' in data && data.exception.values[0].type === 'AbortError') {
        return true
    }

    if ('exceptions' in data && data.exceptions.values[0].type === 'AbortError') {
        return true
    }

    return false
}

const isBannedTrialHostError = data => {
    return 'exception' in data && data.exception.values[0].value === 'Banned trial host' && data.exception.values[0].type === 'Error'
}
